var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "app-switcher" } }, [
    _c("div", { ref: "appSwitcher", staticClass: "app-switcher-overlay" }, [
      _c(
        "div",
        { staticClass: "app-switcher-content" },
        _vm._l(_vm.apps, function (app) {
          return _c("div", { key: app.appKey, staticClass: "app-box" }, [
            _c(
              "div",
              {
                staticClass: "app-link",
                on: {
                  click: function ($event) {
                    return _vm.handleAppClick(app)
                  },
                },
              },
              [
                app.antIcon
                  ? _c("a-icon", {
                      class: ["app-icon", { "is-ant-icon": app.antIcon }],
                      attrs: { type: app.antIcon, fill: "red" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                app.materialIcon
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        class: [
                          "app-icon",
                          { "is-material-icon": app.materialIcon },
                        ],
                      },
                      [_vm._v(_vm._s(app.materialIcon))]
                    )
                  : _c(_vm.getIcon(app), {
                      tag: "component",
                      staticClass: "custom-app-icon",
                      attrs: { fill: "red" },
                    }),
                _vm._v(" "),
                _c("div", { staticClass: "app-name" }, [
                  _vm._v(_vm._s(app.title)),
                ]),
              ],
              1
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }